import script from "./WeightsModalTrigger.vue?vue&type=script&setup=true&lang=js"
export * from "./WeightsModalTrigger.vue?vue&type=script&setup=true&lang=js"

import "./WeightsModalTrigger.vue?vue&type=style&index=0&id=46210994&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46210994"]])

export default __exports__